import Loading from "src/stories/Loading"
import { IExtendedParams } from "../../data/interfaces"
import EditSwitcher from "./landing-edit/EditSwitcher"
import LandingEditor from "./LandingEditor"
import LandingSnapshot from "./LandingSnapshot"
import { isRole } from "src/settings/zustand/user"
import { ILandingConsoleStore, useLandingConsoleStore } from "../../data/store"
import { useEffect, useState } from "react"
import { actions } from "../../data/actions"
import { GET_EXTERNAL_LANDING_ACTION, } from "../../data/actionTypes"

/* Protopia Ecosystem component */
export interface ILandingExternalFormProps {
    extend_params: IExtendedParams
    isAuthor?: boolean
}
const LandingExternalForm = (props: ILandingExternalFormProps): JSX.Element => {
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const isEdit                    = useLandingConsoleStore((state: ILandingConsoleStore) => state.isEdit) 
    const currentDimensionEdit      = useLandingConsoleStore((state: ILandingConsoleStore) => state.currentDimensionEdit)
    
    const setIsEdit = (bool: boolean) => {
        useLandingConsoleStore.setState({ isEdit: bool })
    }
    useEffect(() => {
        setIsLoading(true)
        actions(
            GET_EXTERNAL_LANDING_ACTION, 
            {
                id: props.extend_params?.landing_id, 
                land_id: props.extend_params?.land_id || "1"
            }
        )
        .then(() => {
            setIsLoading(false)

        })
        .catch((err) => {
            setIsLoading(false)
        })
        const layout = document.querySelector("[id='pe-layout-main']")!
        layout.classList.remove("overflow-y-auto")
        layout.classList.add("overflow-hidden") 
        return () => { 
            layout.classList.remove("overflow-hidden")
            layout.classList.add("overflow-y-auto")
        }
    },[ props.extend_params, currentDimensionEdit ])

    

    const is_admin = (): boolean => { 
		return !!props.extend_params.local 
			?
			!!props.extend_params.isEdit
			:
			isRole([ "administrator" ]) || true
	}	
    
    return isLoading
        ?
        <div className="layout-app-state flex-centered">
            <Loading />
        </div>
        :
		<>
			{
				is_admin() && isEdit
					? 
					<LandingEditor   { ...props } isAuthor={ is_admin() } /> 
					: 
					<LandingSnapshot { ...props } isAuthor={ is_admin() } />
			}
			{ 
                is_admin() &&
                <>
                    <EditSwitcher isEdit={isEdit} onSwitch={setIsEdit} />  
                </>    
            }
		</>
}
export default LandingExternalForm